import lodash from 'lodash';
var NotificationType;
(function (NotificationType) {
    NotificationType["EMAIL"] = "email";
    NotificationType["SMS"] = "sms";
})(NotificationType || (NotificationType = {}));
export var GuestType;
(function (GuestType) {
    GuestType["COUNT_ONLY"] = "count_only";
    GuestType["COLLECT_DETAIL"] = "collect_detail";
})(GuestType || (GuestType = {}));
export var LogoShape;
(function (LogoShape) {
    LogoShape["SQUARE"] = "square";
    LogoShape["ROUND"] = "round";
})(LogoShape || (LogoShape = {}));
export var SyncOption;
(function (SyncOption) {
    SyncOption["TWOWAY"] = "twoway";
    SyncOption["ONEWAY"] = "oneway";
    SyncOption["DISABLE_TRIGGER"] = "disable_trigger";
    SyncOption["SMART"] = "smart";
})(SyncOption || (SyncOption = {}));
export var EventType;
(function (EventType) {
    EventType["RoundRobin_OptimizeForAvailability"] = "RoundRobin_OptimizeForAvailability";
    EventType["RoundRobin_OptimizeForEqualDistribution"] = "RoundRobin_OptimizeForEqualDistribution";
    EventType["Collective"] = "Collective";
    EventType["Group"] = "Group";
})(EventType || (EventType = {}));
export var FormSubmitType;
(function (FormSubmitType) {
    FormSubmitType["RedirectURL"] = "RedirectURL";
    FormSubmitType["ThankYouMessage"] = "ThankYouMessage";
})(FormSubmitType || (FormSubmitType = {}));
export var RecurringFrequency;
(function (RecurringFrequency) {
    RecurringFrequency["DAILY"] = "DAILY";
    RecurringFrequency["WEEKLY"] = "WEEKLY";
    RecurringFrequency["MONTHLY"] = "MONTHLY";
})(RecurringFrequency || (RecurringFrequency = {}));
export var RecurringBookingOption;
(function (RecurringBookingOption) {
    RecurringBookingOption["SKIP"] = "skip";
    RecurringBookingOption["CONTINUE"] = "continue";
    RecurringBookingOption["BOOK_NEXT"] = "book_next";
})(RecurringBookingOption || (RecurringBookingOption = {}));
export var RecurringOverlapStatusOption;
(function (RecurringOverlapStatusOption) {
    RecurringOverlapStatusOption["CONFIRMED"] = "confirmed";
    RecurringOverlapStatusOption["UNCONFIRMED"] = "unconfirmed";
})(RecurringOverlapStatusOption || (RecurringOverlapStatusOption = {}));
export var WeekDay;
(function (WeekDay) {
    WeekDay["SUNDAY"] = "SU";
    WeekDay["MONDAY"] = "MO";
    WeekDay["TUESDAY"] = "TU";
    WeekDay["WEDNESDAY"] = "WE";
    WeekDay["THURSDAY"] = "TH";
    WeekDay["FRIDAY"] = "FR";
    WeekDay["SATURDAY"] = "SA";
})(WeekDay || (WeekDay = {}));
export var CalendarType;
(function (CalendarType) {
    CalendarType["ROUND_ROBIN"] = "round_robin";
    CalendarType["EVENT"] = "event";
    CalendarType["CLASS_BOOKING"] = "class_booking";
    CalendarType["COLLECTIVE"] = "collective";
})(CalendarType || (CalendarType = {}));
export var WidgetType;
(function (WidgetType) {
    WidgetType["DEFAULT"] = "default";
    WidgetType["CLASSIC"] = "classic";
})(WidgetType || (WidgetType = {}));
function camelize(obj) {
    return lodash.transform(obj, (acc, value, key) => {
        const camelKey = lodash.camelCase(key);
        acc[camelKey] = value;
    });
}
export default class Calendar {
    constructor(data) {
        this.data = {};
        this.data = data;
    }
    set id(id) {
        this.data.id = id;
    }
    get id() {
        return this.data.id;
    }
    set name(name) {
        this.data.name = name;
    }
    get name() {
        return this.data.name;
    }
    get providerId() {
        return this.data.providerId;
    }
    set providerId(providerId) {
        this.data.providerId = providerId;
    }
    get calendarType() {
        return this.data.calendarType;
    }
    set calendarType(value) {
        this.data.calendarType = value;
    }
    get widgetType() {
        return this.data.widgetType;
    }
    set widgetType(value) {
        this.data.widgetType = value;
    }
    get isLivePaymentMode() {
        return this.data.isLivePaymentMode;
    }
    set isLivePaymentMode(mode) {
        this.data.isLivePaymentMode = mode;
    }
    get stripe() {
        return this.data.stripe;
    }
    set stripe(stripe) {
        this.data.stripe = stripe;
    }
    get widgetSlug() {
        return this.data.widgetSlug;
    }
    set widgetSlug(value) {
        this.data.widgetSlug = value;
    }
    get eventTitle() {
        return this.data.eventTitle;
    }
    set eventTitle(value) {
        this.data.eventTitle = value;
    }
    get linkedCalendars() {
        if (!this.data.linkedCalendars) {
            this.data.linkedCalendars = {};
        }
        if (!this.data.linkedCalendars.google) {
            this.data.linkedCalendars.google = {};
        }
        return this.data.linkedCalendars;
    }
    set linkedCalendars(linkedCalendars) {
        this.data.linkedCalendars = linkedCalendars;
    }
    get syncOption() {
        return this.data.syncOption || SyncOption.ONEWAY;
    }
    set syncOption(syncOption) {
        this.data.syncOption = syncOption;
    }
    get meetingLocation() {
        return this.data.meetingLocation;
    }
    set meetingLocation(value) {
        this.data.meetingLocation = value;
    }
    get eventColor() {
        return this.data.eventColor;
    }
    set eventColor(value) {
        this.data.eventColor = value;
    }
    get version() {
        return this.data.version;
    }
    set version(value) {
        this.data.version = value;
    }
    get groupName() {
        return this.data.providerId;
    }
    set groupName(groupName) {
        this.data.groupName = groupName;
    }
    get isV3Calendar() {
        return (this.data.calendarType === CalendarType.ROUND_ROBIN ||
            this.data.calendarType === CalendarType.CLASS_BOOKING ||
            this.data.calendarType === CalendarType.COLLECTIVE);
    }
    get isEventCalendar() {
        return this.calendarType === CalendarType.EVENT;
    }
    get isRoundRobinCalendar() {
        return this.calendarType === CalendarType.ROUND_ROBIN;
    }
    get isClassBookingCalendar() {
        return this.calendarType === CalendarType.CLASS_BOOKING;
    }
    get isRecurringCalendar() {
        return this.data.enableRecurring;
    }
    get teamMembers() {
        var _a;
        if (this.data.teamMembers) {
            return (_a = this.data.teamMembers) === null || _a === void 0 ? void 0 : _a.map(member => camelize(member));
        }
        return this.data.teamMembers;
    }
    set teamMembers(teamMembers) {
        this.data.teamMembers = teamMembers.map(member => camelize(member));
    }
    get openHours() {
        return this.data.openHours;
    }
    set openHours(openHours) {
        this.data.openHours = openHours;
    }
    get availabilities() {
        return this.data.availabilities;
    }
    set availabilities(availabilities) {
        this.data.availabilities = availabilities;
    }
    get availabilityType() {
        return this.data.availabilityType;
    }
    set availabilityType(availabilityType) {
        this.data.availabilityType = availabilityType;
    }
    get slotDuration() {
        return Number(this.data.slotDuration);
    }
    set slotDuration(slotDuration) {
        this.data.slotDuration = slotDuration;
    }
    get slotInterval() {
        return Number(this.data.slotInterval);
    }
    set slotInterval(slotInterval) {
        this.data.slotInterval = slotInterval;
    }
    get slotIntervalUnit() {
        return this.data.slotIntervalUnit;
    }
    set slotIntervalUnit(slotIntervalUnit) {
        this.data.slotIntervalUnit = slotIntervalUnit;
    }
    get slotBuffer() {
        return this.data.slotBuffer;
    }
    set slotBuffer(slotBuffer) {
        this.data.slotBuffer = slotBuffer;
    }
    get slotBufferUnit() {
        return this.data.slotBufferUnit;
    }
    set slotBufferUnit(slotBufferUnit) {
        this.data.slotBufferUnit = slotBufferUnit;
    }
    get allowBookingFor() {
        return this.data.allowBookingFor;
    }
    set allowBookingFor(allowBookingFor) {
        this.data.allowBookingFor = allowBookingFor;
    }
    get allowBookingForUnit() {
        return this.data.allowBookingForUnit;
    }
    set allowBookingForUnit(allowBookingForUnit) {
        this.data.allowBookingFor = allowBookingForUnit;
    }
    get allowBookingAfter() {
        return this.data.allowBookingAfter;
    }
    set allowBookingAfter(allowBookingAfter) {
        this.data.allowBookingAfter = allowBookingAfter;
    }
    get allowBookingAfterUnit() {
        return this.data.allowBookingAfterUnit;
    }
    set allowBookingAfterUnit(allowBookingAfterUnit) {
        this.data.allowBookingAfterUnit = allowBookingAfterUnit;
    }
    get appoinmentPerSlot() {
        return Number(this.data.appoinmentPerSlot) || 1;
    }
    set appoinmentPerSlot(appoinmentPerSlot) {
        this.data.appoinmentPerSlot = appoinmentPerSlot;
    }
    get appoinmentPerDay() {
        return this.data.appoinmentPerDay;
    }
    set appoinmentPerDay(appoinmentPerDay) {
        this.data.appoinmentPerDay = appoinmentPerDay;
    }
    get slotDurationUnit() {
        return this.data.slotDurationUnit;
    }
    set slotDurationUnit(slotDurationUnit) {
        this.data.slotDurationUnit = slotDurationUnit;
    }
    get order() {
        return Number(this.data.order);
    }
    get isActive() {
        return this.data.isActive !== false;
    }
    set isActive(isActive) {
        this.data.isActive = isActive;
    }
    get dateUpdated() {
        return this.data.dateUpdated;
    }
    get slug() {
        return this.data.slug;
    }
    get locationId() {
        return this.data.locationId;
    }
    set locationId(locationId) {
        this.data.locationId = locationId;
    }
    get enableRecurring() {
        return this.data.enableRecurring;
    }
    set enableRecurring(value) {
        this.data.enableRecurring = value;
    }
    get recurring() {
        return this.data.recurring;
    }
    set recurring(value) {
        this.data.recurring = value;
    }
    get isCustomRecurrence() {
        var _a;
        return !!((_a = this.data.recurring) === null || _a === void 0 ? void 0 : _a.interval);
    }
    get description() {
        return this.data.description;
    }
    get groupId() {
        return this.data.groupId;
    }
    get thanksMessage() {
        return this.data.thanksMessage
            ? this.data.thanksMessage
            : 'Thank you for your appointment request. We will contact you shortly to confirm your request. Please call our office at {{contactMethod}} if you have any questions.';
    }
    set thanksMessage(thanksMessage) {
        this.data.thanksMessage = thanksMessage;
    }
    get thankyouURL() {
        return this.data.thankyouURL;
    }
    set thankyouURL(thankyouURL) {
        this.data.thankyouURL = thankyouURL;
    }
    get formSubmitType() {
        return (this.data.formSubmitType ||
            (this.thankyouURL
                ? FormSubmitType.RedirectURL
                : FormSubmitType.ThankYouMessage));
    }
    set formSubmitType(value) {
        this.data.formSubmitType = value;
    }
    // After form submit either it shows the formSubmitThanksMessage or redirect widget page to the formSubmitRedirectURL
    get formSubmitRedirectURL() {
        return this.data.formSubmitRedirectUrl || this.thankyouURL;
    }
    set formSubmitRedirectURL(value) {
        this.data.formSubmitRedirectUrl = value;
    }
    // After form submit either it shows the formSubmitThanksMessage or redirect widget page to the formSubmitRedirectURL
    get formSubmitThanksMessage() {
        return this.data.formSubmitThanksMessage || this.thanksMessage;
    }
    set formSubmitThanksMessage(value) {
        this.data.formSubmitThanksMessage = value;
    }
    get stickyContact() {
        return this.data.stickyContact !== undefined
            ? this.data.stickyContact
            : false;
    }
    set stickyContact(stickyContact) {
        this.data.stickyContact = stickyContact;
    }
    get formId() {
        return this.data.formId;
    }
    set formId(formId) {
        this.data.formId = formId;
    }
    get codeBlock() {
        return this.data.codeBlock;
    }
    set codeBlock(codeBlock) {
        this.data.codeBlock = codeBlock;
    }
    get allowReschedule() {
        var _a;
        return (_a = this.data.allowReschedule) !== null && _a !== void 0 ? _a : true;
    }
    set allowReschedule(allowReschedule) {
        this.data.allowReschedule = allowReschedule;
    }
    get allowCancellation() {
        var _a;
        return (_a = this.data.allowCancellation) !== null && _a !== void 0 ? _a : true;
    }
    set allowCancellation(allowCancellation) {
        this.data.allowCancellation = allowCancellation;
    }
    get enableStaffSelection() {
        return this.data.enableStaffSelection;
    }
    set enableStaffSelection(enableStaffSelection) {
        this.data.enableStaffSelection = enableStaffSelection;
    }
    get notes() {
        let defaultText = this.data.notes ||
            'Phone:- {{contact.phone}}\nEmail:- {{contact.email}}\n\nNeed to make a change to this event?\nReschedule:-\n{{reschedule_link}}\n\nCancel:-\n{{cancellation_link}}';
        if (!this.allowReschedule) {
            defaultText = defaultText.replace(Calendar.NotesText_Reschedule, '');
        }
        if (!this.allowCancellation) {
            defaultText = defaultText.replace(Calendar.NotesText_Cancellation, '');
        }
        return defaultText;
    }
    set notes(notes) {
        this.data.notes = notes;
    }
    get pixelId() {
        return this.data.pixelId;
    }
    set pixelId(pixelId) {
        this.data.pixelId = pixelId;
    }
    get autoConfirm() {
        if (this.data.autoConfirm === undefined) {
            return true;
        }
        return this.data.autoConfirm;
    }
    set autoConfirm(autoConfirm) {
        this.data.autoConfirm = autoConfirm;
    }
    get notifications() {
        return this.data.notifications || [];
    }
    set notifications(notifications) {
        this.data.notifications = notifications;
    }
    get eventType() {
        return this.data.eventType;
    }
    set eventType(value) {
        this.data.eventType = value;
    }
    get widgetLogo() {
        return this.data.widgetLogo || { url: '', shape: LogoShape.SQUARE };
    }
    set widgetLogo(value) {
        this.data.widgetLogo = value;
    }
    get reserveService() {
        return this.data.reserveService !== undefined
            ? this.data.reserveService
            : false;
    }
    set reserveService(reserveService) {
        this.data.reserveService = reserveService;
    }
    get homeServiceData() {
        return this.data.homeServiceData === undefined
            ? {}
            : this.data.homeServiceData;
    }
    set homeServiceData(homeServiceData) {
        this.data.homeServiceData = homeServiceData;
    }
    get price() {
        return this.data.price === undefined ? {} : this.data.price;
    }
    set price(value) {
        this.data.price = value;
    }
    get googleInvitationEmails() {
        var _a;
        return (_a = this.data.googleInvitationEmails) !== null && _a !== void 0 ? _a : false;
    }
    set googleInvitationEmails(googleInvitationEmails) {
        this.data.googleInvitationEmails = googleInvitationEmails;
    }
    get shouldAssignContactToTeamMember() {
        return this.data.shouldAssignContactToTeamMember;
    }
    set shouldAssignContactToTeamMember(shouldAssignContactToTeamMember) {
        this.data.shouldAssignContactToTeamMember = shouldAssignContactToTeamMember;
    }
    get shouldSkipAssigningContactForExisting() {
        return this.data.shouldSkipAssigningContactForExisting;
    }
    set shouldSkipAssigningContactForExisting(shouldSkipAssigningContactForExisting) {
        this.data.shouldSkipAssigningContactForExisting =
            shouldSkipAssigningContactForExisting;
    }
    get enableGuests() {
        return this.data.enableGuests;
    }
    set enableGuests(value) {
        this.data.enableGuests = value;
    }
    get guestType() {
        return this.data.guestType || GuestType.COLLECT_DETAIL;
    }
    get shouldSendCustomForm() {
        return this.data.shouldSendCustomForm;
    }
    set shouldSendCustomForm(value) {
        this.data.shouldSendCustomForm = value;
    }
    get shouldCollectGuestInfo() {
        return (this.data.enableGuests && this.data.guestType === GuestType.COLLECT_DETAIL);
    }
    get shouldCollectGuestCountOnly() {
        return (this.data.enableGuests && this.data.guestType === GuestType.COUNT_ONLY);
    }
}
Calendar.NotesText_Title_RescheduleOrCancellation = 'Need to make a change to this event?\n';
Calendar.NotesText_Reschedule = 'Reschedule:-\n{{reschedule_link}}\n\n';
Calendar.NotesText_Cancellation = 'Cancel:-\n{{cancellation_link}}';
